import { render } from "./KPIAvailabilityChart.vue?vue&type=template&id=1a856d4a&scoped=true"
import script from "./KPIAvailabilityChart.vue?vue&type=script&lang=js"
export * from "./KPIAvailabilityChart.vue?vue&type=script&lang=js"

import "./KPIAvailabilityChart.vue?vue&type=style&index=0&id=1a856d4a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a856d4a"]])

export default __exports__